/*
  <NavTab
    list={}                Links Array
    index={}               Active tab index
    setIndex={setIndex}    Requeried (it changes the active tab)
    full                   fill width
  />
*/
import React from "react";
import styled from "styled-components";

const NavTab = (props) => {
  return (
    <NavTabStyle {...props}>
      {<div>
        {props.list.map(function (object, i) {
          return (
            <Item
              onClick={() => {
                props.setIndex(i + 1);
              }}
              active={props.index === i + 1 ? "active" : ""}
              key={i}
              full={props.full}
            >
              {object}
            </Item>
          );
        })}
      </div>}
      {props.rightComponent}
    </NavTabStyle>
  );
};
export default NavTab;

const NavTabStyle = styled.div`
  display: flex;
  scrollbar-width: none;
  align-items: center;
  position: relative;
  margin-bottom: 24px;
  justify-content: space-between;
  flex-wrap: wrap-reverse;
  & > div:nth-child(1) {
    ${({ theme }) => theme.hideScroller}
    display: flex;
    overflow-y: auto;
    margin-right: auto;
  }
  & > div:nth-child(2) {
    margin-left: auto;
  }
  ::after {
    content: " ";
    background-color: ${({ theme }) => theme.color.border};
    position: absolute;
    height: 2px;
    bottom: 0;
    left: 0;
    right: 0;
  }
  > div {
    ${({ full }) =>
      full &&
      `
    width: 100%;
    text-align: center;
    `}
  }
  @media (max-width: 576px) {
    justify-content: flex-end;
  }
`;

const Item = styled.div`
  user-select: none;
  white-space: nowrap;
  padding: 15px 20px;
  font-family: "Poppins Medium";
  font-weight: 500;
  font-size: 14px;
  text-transform: capitalize;
  line-height: 100%;
  border-bottom: 2px solid;
  color: ${({ active }) =>
    active ? ({ theme }) => theme.color.primary : ({ theme }) => theme.color.secondaryIcon};
  border-color: ${({ active }) =>
    active ? ({ theme }) => theme.color.primary : ({ theme }) => theme.color.border};
  cursor: pointer;
  z-index: 1;
  transition: all 200ms;
  ${({ full }) =>
    full &&
    `
    flex: 1;
    `}
  :hover {
    color: ${({ theme }) => theme.color.primary};
  }
`;
